import React from "react";
// import { CgPlayListRemove } from "react-icons/cg";
import { AiOutlineCheck } from "react-icons/ai";
import FileDownloader from "../../components/UI/Button/FileDownloader";

const AndamentoOsDetalhamento = ({ data }) => {
  if (!data?.anexos?.length) {
    return (
      <div className="m-2">
        <span className="m-0 font-weight-bold text-primary flex-grow-1 px-3">Nenhum anexo para este andamento</span>
      </div>
    );
  }

  return (
    <div className="text-left m-4">
      <h5>Anexos</h5>
      <ul className="list-group">
        {data.anexos.map((item) => (
          <li className="list-group-item" key={item.descricao}>
            <AiOutlineCheck className="text-success" />
            &nbsp;
            {item.descricao ? `${item.nomeArquivo} -> ${item.descricao}` : item.nomeArquivo}
            <FileDownloader
              binario={item.documento}
              nomeArquivo={item.nomeArquivo}
              tooltip={item.descricao ? `${item.nomeArquivo} -> ${item.descricao}` : item.nomeArquivo}
              className="ml-2"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AndamentoOsDetalhamento;
